var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 8.33333H5.33333C4.23973 8.33291 3.16682 8.63143 2.23058 9.1966C1.29435 9.76177 0.530401 10.5721 0.0213343 11.54C0.00702532 11.3604 -9.15218e-05 11.1802 8.88408e-07 11C8.88408e-07 7.318 2.98467 4.33333 6.66667 4.33333V0.666664L13.6667 6.33333L6.66667 12V8.33333ZM5.33333 7H8V9.20533L11.5473 6.33333L8 3.46133V5.66666H6.66667C5.90017 5.6658 5.14253 5.83054 4.44559 6.14961C3.74866 6.46868 3.12888 6.93455 2.62867 7.51533C3.48955 7.17414 4.40731 6.99928 5.33333 7Z",
    fill: "#2DC3E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareapp);
export default __webpack_public_path__ + "static/media/Shareapp.7995e5e5b1e3e564930df569787427dc.svg";
export { ForwardRef as ReactComponent };